import { createClient } from '@supabase/supabase-js'

// Utilizza variabili d'ambiente per sicurezza
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Validazione delle variabili d'ambiente
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Variabili d\'ambiente Supabase mancanti. Controlla .env.local')
  // In sviluppo, possiamo usare valori di fallback solo per debug
  if (process.env.NODE_ENV === 'development') {
    console.warn('Running in development mode with fallback values')
  } else {
    throw new Error('Configurazione Supabase mancante')
  }
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// `key` è anche la chiave dell'icona: la resolve <StationIcon> in
// src/lib/stationIcons.js. Prima qui c'erano emoji, che cambiano forma su
// ogni sistema operativo e non si possono colorare.
export const STATIONS = [
  { key: 'skierg', label: 'SkiErg' },
  { key: 'sled_push', label: 'Sled Push' },
  { key: 'sled_pull', label: 'Sled Pull' },
  { key: 'burpee_broad_jump', label: 'Burpee Broad Jump' },
  { key: 'rowing', label: 'Rowing' },
  { key: 'farmers_carry', label: 'Farmers Carry' },
  { key: 'sandbag_lunges', label: 'Sandbag Lunges' },
  { key: 'wall_balls', label: 'Wall Balls' },
]

export const HR_ZONES = [
  { key: 'z1', label: 'Z1', color: '#6b7280' },
  { key: 'z2', label: 'Z2', color: '#16A34A' },
  { key: 'z3', label: 'Z3', color: '#B18706' },
  { key: 'z4', label: 'Z4', color: '#EA580C' },
  { key: 'z5', label: 'Z5', color: '#ef4444' },
]

export const RUN_TYPES = [
  { key: 'z2_facile',  label: 'Z2 Facile',  color: '#00A344' },
  { key: 'intervalli', label: 'Intervalli',  color: '#EA580C' },
  { key: 'tempo_run',  label: 'Tempo Run',   color: '#D57506' },
  { key: 'long_run',   label: 'Long Run',    color: '#007AFF' },
  { key: 'simulate',   label: 'Simulate',    color: '#E00D31' },
  { key: 'gps',        label: 'GPS Tracker', color: '#0E9BB1' },
]

export const PHASES = [
  { key: 'fase1', label: 'Fase 1 · Aerobica', color: '#3b82f6' },
  { key: 'fase2', label: 'Fase 2 · Ibrida', color: '#B18706' },
  { key: 'fase3', label: 'Fase 3 · Gara', color: '#ef4444' },
]

export const MUSCLE_GROUPS = [
  'petto', 'spalle', 'tricipiti', 'dorso', 'bicipiti', 'gambe', 'glutei', 'core'
]

export const TECHNIQUES = [
  { key: 'standard', label: 'Standard' },
  { key: 'rest_pause', label: 'Rest-Pause (RP)' },
  { key: 'drop_set', label: 'Drop Set (DS)' },
  { key: 'myo_reps', label: 'Myo-reps' },
  { key: 'cluster', label: 'Cluster' },
]
